import React from "react";
import { css, cx } from "react-emotion";
import moment from "moment";
import "moment/locale/de";

import Button from "components/Button";
import { observer } from "mobx-react";
import { SingleDatePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
// import styles from "./"css"";
import InputSelect from "./InputSelect";

moment.locale("de");

class InputDate extends React.Component {
  datePickerRef = React.createRef();
  state = { focused: null, date: null, onMountValue: "" };

  componentDidMount() {
    const { store, name } = this.props;

    this.setState({ onMountValue: store.get(name) });
  }

  onSubmit = () => {
    const { onSubmit } = this.props;
    onSubmit && onSubmit();
    this.setState({ focused: false });
  };

  onClear = () => {
    const { onClear } = this.props;
    onClear && onClear();
    this.setState({ focused: false });
  };

  onCancel = () => {
    const { store, name } = this.props;
    const { onMountValue } = this.state;

    store.set(name, onMountValue);
    this.setState({ focused: false });
  };

  onOutsideClick = () => {
    this.onCancel();
  };

  render() {
    const { emStyles, datePickerRef, onOutsideClick } = this;
    const {
      store,
      id,
      label,
      inputWidth = "",
      labelWidth = "",
      formGroupAdd = [],
      name,
      // inputRef,
      placeholder,
      onChange,
      // onKeyPress,
      // type,
      withClear = false,
      useTime = true,
      customInputIcon = null,
      inputIconPosition = "after",
      withPortal = true,
      withOutsideClick = false,
    } = this.props;

    const tempValue = store && store.data && store.get(name);

    const tempValueValid = tempValue && moment(tempValue).isValid();
    const value = tempValueValid ? tempValue : moment().format("YYYY-MM-DD");
    const currentDate = moment(value).format("YYYY-MM-DD");
    const hourOptions = Array(...Array(24)).reduce((result, el, i) => {
      const hour = `0${i}`.slice(-2);
      result.push({ value: `${currentDate}T${hour}:00`, label: `${hour}:00` });
      result.push({ value: `${currentDate}T${hour}:30`, label: `${hour}:30` });

      return result;
    }, []);

    return (
      <div className={[cx("inputDateRoot", emStyles.root)]}>
        {label && (
          <label
            htmlFor={id}
            onClick={() => this.input.focus()}
            className={["control-label", labelWidth, "labelUnactive"].join(" ")}
          >
            <span className={"labelText"}>{label || name}</span>
            <span className={"labelBackground"} />
          </label>
        )}

        <div className={inputWidth}>
          <SingleDatePicker
            ref={datePickerRef}
            withPortal={withPortal}
            keepOpenOnDateSelect
            hideKeyboardShortcutsPanel
            // showDefaultInputIcon
            displayFormat={() => (useTime ? "DD.MM.YYYY HH:mm" : "DD.MM.YYYY")}
            numberOfMonths={1}
            placeholder={placeholder}
            date={tempValueValid ? moment(value) : null}
            customInputIcon={tempValueValid ? customInputIcon : null}
            inputIconPosition={inputIconPosition}
            onDateChange={date => {
              const d = date || moment();
              onChange({
                target: { name, value: `${d.format("YYYY-MM-DD")}T${moment(value).format("HH:mm")}` },
              });
            }}
            focused={this.state.focused}
            onFocusChange={({ focused }) => {
              this.setState({ focused });
              if (withOutsideClick && !focused) {
                onOutsideClick();
              }
            }}
            renderCalendarInfo={() => (
              <div>
                {useTime && (
                  <div className={cx(["timeInput", emStyles.calendarPadding])}>
                    <InputSelect
                      labelWidth="col-xs-4"
                      inputWidth="col-xs-4"
                      label="Uhrzeit"
                      store={store}
                      name={name}
                      options={hourOptions}
                    />
                  </div>
                )}

                <div style={{ clear: "both" }} />
                <div className={emStyles.calendarPadding}>
                  <div className={"buttonCancel"} style={{ float: "left" }}>
                    <Button motif="text" tag="a" size="small" onClick={this.onCancel}>
                      Abbrechen
                    </Button>
                  </div>
                  <div style={{ float: "right" }}>
                    <Button size="small" onClick={this.onSubmit}>
                      Speichern
                    </Button>
                  </div>
                  <div style={{ clear: "both" }} />
                  {withClear && (
                    <div className={emStyles.clear}>
                      <div style={{ float: "right" }}>
                        <Button motif="text" tag="a" size="small" onClick={this.onClear}>
                          Termin löschen
                        </Button>
                      </div>
                      <div style={{ clear: "both" }} />
                    </div>
                  )}
                </div>
              </div>
            )}
          />
        </div>

        {formGroupAdd}

        {store && store.errors && store.errors[name] && (
          <p className={"error"}>
            <small>{store.errors[name]}</small>
          </p>
        )}
      </div>
    );
  }
  emStyles = {
    root: css`
      input[type="text"].DateInput_input {
        border: 0 !important;
      }
    `,
    clear: css`
      margin-top: 10px;
    `,
    calendarPadding: css`
      padding: 0px 23px;
      margin-bottom: 23px;
    `,
  };
}

export default observer(InputDate);
